





































import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";

@Component
export default class ExpandableCriteresRecus extends mixins(MyMixin) {
  public filter!: any;
  @Prop() public filtres!: any;

  public mounted() {
    this.$emit("updateParam", this.mesFiltres);
  }

  public updateFiltres(filtre: any) {
    this.$emit("updateParam", this.mesFiltres);
  }

  get mesFiltres() {
    return this.filtres;
  }
}
